<template>
  <AppModal
    :bottom-sheet="true"
    :title="$t('general.edit_categories')"
    :visible.sync="modalVisible"
    max-height="90vh"
    width="560px"
    @close="onClose"
  >
    <!-- Yeni kategori ekleme -->
    <div class="category-edit-modal__add-row">
      <input
        v-model="newCategory"
        :placeholder="$t('general.new_category_title')"
        class="form-control category-edit-modal__input"
        type="text"
        @keyup.enter="handleAddCategory"
      >
      <button
        class="btn btn-sm btn-secondary btn-icon-label category-edit-modal__add-btn"
        @click="handleAddCategory"
      >
        <span class="btn-inner--icon"><i class="uil-plus"></i></span>
        <span class="btn-inner--text">{{ $t('general.add') }}</span>
      </button>
    </div>

    <!-- Kategori listesi -->
    <div class="category-edit-modal__list">
      <div
        v-for="(element, index) in categories"
        :key="index"
        class="category-edit-modal__item"
      >
        <input
          v-model="element.name"
          :placeholder="$t('general.new_category_title')"
          class="form-control category-edit-modal__input"
          type="text"
        >
        <div class="category-edit-modal__item-actions">
          <button
            class="btn btn-icon btn-hover btn-sm btn-circle category-edit-modal__action-btn category-edit-modal__action-btn--save"
            @click="handleSaveCategory(element, index)"
          >
            <i :class="{ 'text-success': savedUpdateIndex === index }" class="uil-check"/>
          </button>
          <button
            class="btn btn-icon btn-hover btn-sm btn-circle category-edit-modal__action-btn category-edit-modal__action-btn--delete"
            @click="handleDeleteCategory(element, index)"
          >
            <i class="uil-trash text-danger"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <template #footer>
      <button
        class="uk-button uk-button-default category-edit-modal__close-btn"
        type="button"
        @click="hide"
      >
        {{ $t("general.close") }}
      </button>
    </template>
  </AppModal>
</template>

<script>
import AppModal from "@/view/components/ui/AppModal.vue";

export default {
  name: "CategoryEditModal",
  components: {
    AppModal
  },
  props: {
    categories: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      modalVisible: false,
      newCategory: '',
      savedUpdateIndex: null
    }
  },
  methods: {
    show() {
      this.modalVisible = true;
    },
    hide() {
      this.modalVisible = false;
    },
    onClose() {
      this.modalVisible = false;
    },
    handleAddCategory() {
      if (this.newCategory && this.newCategory.trim()) {
        this.$emit('add-category', this.newCategory.trim());
        this.newCategory = '';
      }
    },
    handleSaveCategory(element, index) {
      this.$emit('save-category', { element, index });
      this.savedUpdateIndex = index;
      setTimeout(() => {
        this.savedUpdateIndex = null;
      }, 2000);
    },
    handleDeleteCategory(element, index) {
      this.$emit('delete-category', { element, index });
    }
  }
}
</script>

<style scoped>
.category-edit-modal__add-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e2e8f0;
}

.category-edit-modal__input {
  flex: 1;
  min-width: 0;
  box-sizing: border-box;
  height: 40px;
  min-height: 40px;
  padding: 8px 12px;
  border: 1px solid #cfd5df;
  border-radius: 10px;
  font-size: 15px;
  line-height: 1.5;
  color: #1e293b;
  -webkit-appearance: none;
  appearance: none;
}

.category-edit-modal__input:focus {
  border-color: var(--primaryColor, #3e416d);
  box-shadow: 0 0 0 3px rgba(62, 65, 109, 0.16);
  outline: none;
}

.category-edit-modal__add-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  min-height: 40px;
  padding: 8px 16px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  flex-shrink: 0;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
}

.category-edit-modal__list {
  max-height: 360px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.category-edit-modal__item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 0;
  border-bottom: 1px solid #f1f5f9;
}

.category-edit-modal__item:last-child {
  border-bottom: none;
}

.category-edit-modal__item-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

.category-edit-modal__action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  min-width: 36px;
  min-height: 36px;
  padding: 0;
  border-radius: 10px;
  font-size: 18px;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
}

.category-edit-modal__action-btn:active {
  transform: scale(0.95);
  opacity: 0.85;
}

.category-edit-modal__close-btn {
  min-height: 40px;
  padding: 8px 24px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
}

.category-edit-modal__close-btn:active {
  transform: scale(0.98);
  opacity: 0.85;
}

/* ─── Mobile / Tablet ─── */
@media (max-width: 768px) {
  .category-edit-modal__add-row {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  .category-edit-modal__input {
    min-height: 48px;
    height: 48px;
    padding: 12px 16px;
    font-size: 16px;
    line-height: 1.4;
  }

  .category-edit-modal__add-btn {
    width: 100%;
    min-height: 48px;
    padding: 12px 24px;
    font-size: 16px;
    font-weight: 600;
  }

  .category-edit-modal__list {
    max-height: 50vh;
  }

  .category-edit-modal__item {
    padding: 10px 0;
  }

  .category-edit-modal__action-btn {
    width: 44px;
    height: 44px;
    min-width: 44px;
    min-height: 44px;
    font-size: 20px;
  }

  .category-edit-modal__close-btn {
    width: 100%;
    min-height: 48px;
    padding: 12px 24px;
    font-size: 16px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

/* ─── Desktop hover ─── */
@media (hover: hover) and (pointer: fine) {
  .category-edit-modal__action-btn:hover {
    background-color: #f1f5f9;
  }

  .category-edit-modal__add-btn:hover,
  .category-edit-modal__close-btn:hover {
    opacity: 0.92;
  }
}

/* ─── Reduced motion ─── */
@media (prefers-reduced-motion: reduce) {
  .category-edit-modal__action-btn:active,
  .category-edit-modal__close-btn:active {
    transform: none;
  }
}
</style>
